export const featurePage = {
  pageName: 'Exchange',
  productName1: 'Experience Platform Services',
  productName2: 'Audience Manager',
  productName3: 'Acrobat Sign',
  sectionHeadingForProducts: 'Product Section',
  siteSection: 'Exchange:homePage',
  language: 'en-US',
  geoRegion: 'US',
};

export const browsePage = {
  pageName: 'Exchange:Browse',
  sectionHeadingForFeaturedCarousel: 'Featured-carousel',
  sectionHeadingForFeaturedCard: 'Featured-carousel-card',
  defaultFilterKeyword: 'Most Recent',
  defaultFilterCategory: 'Sort By',
  siteSection: 'Exchange:browseappspage',
};

export const publisherPage = {
  pageName: 'Exchange:Publisher',
  siteSection: 'Exchange:publisherpage',
};

export const detailsPage = {
  pageName: 'Exchange:Details',
  siteSection: 'Exchange:productdetailspage',
  sectionHeadingForTagsAndPublisher: 'rightNav',
  sectionHeadingForHelpAndSupport: 'rightNav:Help and support',
  sectionHeadingForCarousel: 'carousel',
  sectionHeadingForMoreByThisPublisher: 'More by this publisher',
  rightNavHelpAndSupportItems: [
    'Get support',
    'Copy share link',
    'Installation',
    'Documentation',
    'Terms of use',
    'Privacy policy',
    'Connect with publisher',
    'Report Abuse',
    'Installation help',
    'Trial Info',
  ],
  sectionHeadingForHeader: 'Header',
};

export const managePage = {
  pageName: 'Exchange:Manage',
  defaultFilterKeyword: 'Most Recent',
  siteSection: 'Exchange:manageappspage',
  SectionHeadingPendingReview: 'Apps pending review',
  SectionHeadingApprovedApps: 'Approved apps',
  SectionHeadingForReviewApp: 'Review app',
  SectionHeadingForRevokeApp: 'Revoke app',
  SectionHeadingReviewApp: 'Review this app',
  SectionHeadingRevokeApp: 'Revoke this app',
  SectionHeadingManageApps: 'Manage CC plugins',
};

export const featurePageEventNameConversion = {
  'Discover Exchange marketplace': 'ListingCard:Experience Cloud',
  'Discover Creative Cloud marketplace': 'ListingCard:Creative Cloud',
  'Featured apps for Experience Cloud view all': 'Featured Apps for Experience Cloud',
  'Featured integrations for Acrobat Sign view all': 'Featured integrations for Acrobat Sign',
}; 